export var TooltipPlacements;
(function (TooltipPlacements) {
    TooltipPlacements["BottomEnd"] = "BOTTOM-END";
    TooltipPlacements["BottomStart"] = "BOTTOM-START";
    TooltipPlacements["Bottom"] = "BOTTOM";
    TooltipPlacements["LeftEnd"] = "LEFT-END";
    TooltipPlacements["LeftStart"] = "LEFT-START";
    TooltipPlacements["Left"] = "LEFT";
    TooltipPlacements["RightEnd"] = "RIGHT-END";
    TooltipPlacements["RightStart"] = "RIGHT-START";
    TooltipPlacements["Right"] = "RIGHT";
    TooltipPlacements["TopEnd"] = "TOP-END";
    TooltipPlacements["TopStart"] = "TOP-START";
    TooltipPlacements["Top"] = "TOP";
})(TooltipPlacements || (TooltipPlacements = {}));
export var TooltipDesignStyles;
(function (TooltipDesignStyles) {
    TooltipDesignStyles["Default"] = "DEFAULT";
    TooltipDesignStyles["Primary"] = "PRIMARY";
})(TooltipDesignStyles || (TooltipDesignStyles = {}));
